<template>
    <div>
        <input
            type="hidden"
            name="send_order_notification_email"
            value="0"
        >
        <checkbox-input
            v-model="shouldSendOrderNotification"
            :value="transformBoolean(shouldSendOrderNotification)"
            name="send_order_notification_email"
        >
            Skicka e-post vid order
        </checkbox-input>

        <div v-show="shouldSendOrderNotification" class="my-md">
            <text-input
                v-model="orderNotificationEmail"
                :value="orderNotificationEmail"
                :error="orderNotificationEmailError"
                type="text"
                name="order_notification_email"
                label="Skicka till e-postadress"
            />
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            initialShouldSendOrderNotification: {
                type: Boolean,
                required: true,
            },
            initialOrderNotificationEmail: {
                type: String,
                default: null,
            },
            orderNotificationEmailError: {
                type: String,
                default: null,
            },
        },

        data() {
            return {
                shouldSendOrderNotification: this.initialShouldSendOrderNotification,
                orderNotificationEmail: this.initialOrderNotificationEmail,
            };
        },

        watch: {
            shouldSendOrderNotification(shouldSendOrderNotification) {
                if (! shouldSendOrderNotification) {
                    this.orderNotificationEmail = '';
                }
            },
        },

        methods: {
            transformBoolean(value) {
                // Prevent posting checkbox values as boolean strings
                return value === true ? 1 : 0;
            },
        },
    };
</script>